import { SubscriptionPlan, ProductsUniqueIds } from "../../../../../global/paywall/paywallInterfaces";

interface PaywallCheckoutFinishProps {
    setShouldRedirect: (shouldRedirect: boolean) => void;
    selectedPlan: SubscriptionPlan | null;
}

const PaywallCheckoutFinish = (props: PaywallCheckoutFinishProps) => {

    const { setShouldRedirect, selectedPlan } = props;
    const isMonthly = selectedPlan.productUniqueId === ProductsUniqueIds.MONTHLY_PASS;
    const planTitle = isMonthly ? "חבילה בחיוב חודשי מתחדש" : "חבילה בחיוב שנתי מתחדש";
    const planPrice = isMonthly ? "₪29.90 לחודש" : "₪299.90 לשנה";
    return (
        <div className="PaywallCheckoutFinish">
            <div className="title-container">
                <span className="success-logo"></span>
                <span className="title">הרכישה הושלמה!</span>
            </div>
            <div className="subtitle">
                מעכשיו תוכלו להנות מגישה חופשית לכל תכני ידיעות+ ולמהדורה הדיגיטלית של
                <span className="yedioth-logo"></span>
            </div>

            <div className="checkout-container">
                <div className="plan-info">
                    <div className="plan-title">{planTitle}</div>
                    <div className="plan-price-text">{planPrice}</div>
                </div>
                <div className="customer-info">
                    <div className="customer-title">פרטי המנוי</div>
                    <div className="inner-container">
                        <div className="customer-name"></div>
                        <div className="customer-email"></div>
                    </div>
                    <div className="customer-myaccount-info">ניתן לצפות ולערוך את פרטי המנוי <span className="underline">באיזור האישי</span></div>
                </div>
                <div className="payment-info">
                    <div className="payment-title">פרטי התשלום</div>
                    <div className="inner-container">
                        <div className="payment-hodler-name"></div>
                        <div className="payment-cvv"></div>
                    </div>
                </div>
            </div>

            <button className="continue-button" onClick={() => setShouldRedirect(true)}>מעבר לכתבות ידיעות+</button>


        </div>
    );
};

export default PaywallCheckoutFinish;